/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/

import type { AxiosInstance } from 'axios';

import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';

import type { CurrentWeatherInfo } from 'hems/weather';

export default class WeatherService extends Service {
  constructor(axios: AxiosInstance) {
    super(axios);
  }

  /** 현재 날씨 정보 조회 */
  getCurrentWeather = async (siteId: string): Promise<CurrentWeatherInfo> => {
    return await this.get<CurrentWeatherInfo>(apiWrapper.weatherAPI(`/qcells-${siteId}/currentweatherdata`));
  };
}
